import React from 'react'
import { GetRoad } from '../components/getroad/GetRoad'
import { LicenseJourney } from '../components/licensejourney/LicenseJourney'
import { FlexiblesPackages } from '../components/flexiblepackages/FlexiblesPackages'
import { WhyChooseUs } from '../components/whychooseus/WhyChooseUs'
import { ExpertTutions } from '../components/expertTutions/ExpertTutions'
import { FromTeens } from '../components/fromTeens/FromTeens'
import { GetQuestions } from '../components/getQuestions/GetQuestions'

const SiteOne = () => {
  return (
    <>
        <GetRoad/>
    <LicenseJourney/>
    <FlexiblesPackages/>
    <WhyChooseUs/>
    <ExpertTutions/>
    <FromTeens/>
    <GetQuestions/>
    </>
  )
}

export default SiteOne